import { commonRoutes } from 'modules/routes';
import { webRoutes } from './modules/routes';

export const routes = [...commonRoutes, ...webRoutes];
